
const Visualiser = require('../analysis/visualiser')

const d3 = Object.assign({}, require('d3'), require('d3-force'))

const {get} = require('../request')
const {parse} = require('../html')
const layout = require('./network.html')

const {posColour} = require('../pos')

const Network = class extends Visualiser {
    constructor(name, analysis, options={}) {
        super(name, analysis, {
            width: options.width || 1024,
            height: options.height || 1024,
            font: options.font || 'sans-serif',
            onlyKeywords: options.onlyKeywords || false,
            range: -1,
            window: 5,
            minValue: 1,
            fixed: '',
        })
    }
    parseInputs(form) {
        const range = parseInt(form.querySelector('#range').value)
        const window = parseInt(form.querySelector('#window').value)
        const minValue = parseInt(form.querySelector('#min-value').value)
        const fixed = form.querySelector('#fix').value
        return {range, window, minValue, fixed}
    }
    dom() {
        const makeRanges = (arr) => arr.map(n => ({value: n, label: n < 0 ? '전체' : this.summary.names[n]}))
        const ranges = new Array(this.summary.length).fill(0).map((_z, i) => i)
        ranges.unshift(-1)
        const options = [5, 10, 15, 20, 30, 40, 50]

        const content = parse(layout, {ranges: makeRanges(ranges), options}).querySelector('#content')

        const form = content.querySelector('form')
        form.addEventListener('submit', (event) => {
            event.preventDefault()
            Object.assign(this.options, this.parseInputs(form))
            this.update()
            return true
        })

        this.content = content
        return content
    }
    update() {
        const {host, port} = this.api
        const {tokenizer, section, limit, split, pos, password} = this.config.json()
        const {range, window, minValue, fixed, onlyKeywords} = this.options

        if(onlyKeywords && !fixed) return alert('중심 단어를 입력해 주세요.')
            
        const unitIndex = range < 0 ? null : range
        const params = {tokenizer, section, limit, split, unitIndex, pos, window, password}
        get(host, port, `/document/${this.document.name}/network`, params).then(({axis, matrix}) => {
            const wrapper = this.content.querySelector('#wrapper')
            wrapper.innerHTML = ''

            let nodes = axis.map((word, i) => ({id: i, name: word}))
            let links = matrix.map((row, i) => row.map((value, j) => ({source: i, target: j, value}))).flat()
                    .filter((link) => link.value > 0 && link.value >= minValue)

            if(onlyKeywords) links = links.filter((link) => axis[link.source].split('/')[0] == fixed || axis[link.target].split('/')[0] == fixed)
            nodes = nodes.filter((node) => links.find(link => link.source == node.id || link.target == node.id))

            // 중앙에 고정할 노드의 인덱스를 구한다
            const fixedIndex = fixed ? nodes.findIndex(({name}) => name.split('/')[0] == fixed) : null

            if(nodes.length == 0 || fixedIndex !== null && !nodes[fixedIndex]) return alert('해당 설정으로 그릴 수 있는 데이터가 없습니다.')

            if(nodes.length > 30 && !confirm(`해당 설정으로 그릴 수 있는 데이터가 ${nodes.length}개로 너무 많습니다. 계속하시겠습니까?`)) return

            const min = links.map(l => l.value).reduce((a, c) => a > c ? c : a, links[0].value)
            const max = links.map(l => l.value).reduce((a, c) => a < c ? c : a, links[0].value)
            const valueRange = max - min
    
            const svg = d3.select(wrapper)
                    .append('svg')
                        .attr('width', this.options.width)
                        .attr('height', this.options.height)
                    .append('g')
            
            const link = svg
                    .selectAll('line')
                    .data(links)
                    .enter()
                    .append('g')
    
            const line = link
                    .append('line')
                        .style('stroke', '#8888')
                        .style('stroke-width', d => Math.max(Math.log(d.value - min) * 4, 1))
            
            const lineLabel = link
                    .append('text')
                        .text(d => d.value)
                        .attr('fill', '#888')
    
            const node = svg
                    .selectAll('node')
                    .data(nodes)
                    .enter()
                    .append('g')
            
            const circle = node
                    .append('circle')
                        .attr('r', (_d, i) => (i == fixedIndex) ? 20 : 10)
                        .style('fill', d => posColour(d.name.split('/')[1]))
    
            const circleLabel = node
                    .append('text')
                        .text(d => d.name.split('/')[0])
            
            const ticked = () => {
                line
                        .attr('x1', (d) => d.source.x)
                        .attr('y1', (d) => d.source.y)
                        .attr('x2', (d) => d.target.x)
                        .attr('y2', (d) => d.target.y)
                lineLabel
                        .attr('x', (d) => (d.source.x + d.target.x) / 2)
                        .attr('y', (d) => (d.source.y + d.target.y) / 2)
                circle
                        .attr('cx', (d) => d.x)
                        .attr('cy', (d) => d.y)
                circleLabel
                        .attr('x', (d) => d.x)
                        .attr('y', (d) => d.y + 3)
            }
    
            svg.attr('transform', `translate(${this.options.width / 2},${this.options.height / 2})`)
    
            if(fixedIndex !== null) {
                nodes[fixedIndex].fx = 0
                nodes[fixedIndex].fy = 0
            }
    
            const simulation = d3.forceSimulation(nodes)
                    .force('charge', d3.forceManyBody().strength(-1))
                    .force('link', d3.forceLink()
                            .id(d => d.id)
                            .links(links)
                            .distance(d => (max - d.value) * this.options.width/2/(valueRange+1))
                            .strength(2)
                    )
                    .force('center', d3.forceCenter(0, 0))
                    .force('collide', d3.forceCollide().strength(1).radius(20))
                    .on('tick', ticked)
                    .alpha(0.1)
        })
    }
    data({word}) {
        if(this.content) {
            const form = this.content.querySelector('form')
            form.querySelector('#fix').value = word
            Object.assign(this.options, this.parseInputs(form))
            this.update()
        }
    }
    word(word) {
        this.data({word})
    }
}

module.exports = Network
